import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <circle cx="16" cy="16" r="16" fill="#fff"></circle>
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M18.485 14.457l-.942-.942-6.21 6.209v.943h.943l6.21-6.21zm.943-.942l.943-.943-.943-.943-.943.943.943.943zM12.828 22H10v-2.829l8.957-8.956a.666.666 0 01.942 0l1.886 1.886a.666.666 0 010 .942L12.83 22h-.001z"
      ></path>
    </svg>
  )
}

export default Icon
